export const CLIENT_SCORING_RESULT_SCORING_STATUS = {
  Pending: 1,
  RejectedHighRisk: 2,
  Escalated: 3,
  ApprovedHighRisk: 4,
  ApprovedMediumRisk: 5,
  ApprovedNormalRisk: 6,
};

export const clientScoringResultScoringStatusOptions = [{
  value: CLIENT_SCORING_RESULT_SCORING_STATUS.Pending,
  label: 'Pending',
}, {
  value: CLIENT_SCORING_RESULT_SCORING_STATUS.RejectedHighRisk,
  label: 'Rejected High Risk',
}, {
  value: CLIENT_SCORING_RESULT_SCORING_STATUS.Escalated,
  label: 'Escalated',
},
{
  value: CLIENT_SCORING_RESULT_SCORING_STATUS.ApprovedHighRisk,
  label: 'Approved High Risk',
},
{
  value: CLIENT_SCORING_RESULT_SCORING_STATUS.ApprovedMediumRisk,
  label: 'Approved Medium Risk',
},
{
  value: CLIENT_SCORING_RESULT_SCORING_STATUS.ApprovedNormalRisk,
  label: 'Approved Normal Risk',
},
];


// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/constants/clientScoringResultConstants.js